module.exports = __webpack_public_path__ + "static/media/illustration-nenhum-habilidade.13099327.svg";